<ngx-invisible-recaptcha #captchaElem
                         [siteKey]="siteKey"
                         (reset)="handleReset()"
                         (ready)="handleReady()"
                         (load)="handleLoad()"
                         (expire)="handleError($event)"
                         (error)="handleError($event)"
                         (success)="handleSuccess($event)"
                         [useGlobalDomain]="false"
                         [type]="type"
                         [theme]="theme"
                         [badge]="badge"
                         [ngModel]="recaptcha"
                         [ngModelOptions]="{ standalone: false }">
</ngx-invisible-recaptcha>
